module.exports = __webpack_public_path__ + "0274637afddb77edfc3c5d1901f8fd78.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Dog2.jpg
// module id = 3269
// module chunks = 0